module.exports = __webpack_public_path__ + "assets/img/copyright-icon.458f0b7a.png";